/**
 * Atelier Diamante — Contact Page Alpine Component (v2)
 * Native {% form 'contact' %} submit (reCAPTCHA-compatible). Success shown after
 * the post-submit reload by detecting ?contact_posted=true. Intent/budget drive
 * dynamic fields + hidden inputs carried to the email.
 */
(function () {
  'use strict';

  const CONFIG = window.AD_ContactConfig || {
    whatsappUrl: '', calendlyUrl: '', notionWebhookUrl: '',
    daveName: 'Dave Gandhi', daveEmail: 'dave@atelierdiamante.com', responseTime: 'Within 24 hours',
  };

  const INTENTS = {
    engagement: {
      label: 'Engagement Ring',
      budgets: ['Under $5k', '$5k to $10k', '$10k to $25k', '$25k and up', 'Let Dave advise'],
      defaultBudget: '$5k to $10k',
    },
    jewelry: {
      label: 'Fine Jewelry',
      budgets: ['Under $2k', '$2k to $5k', '$5k to $15k', '$15k and up', 'Let Dave advise'],
      defaultBudget: 'Let Dave advise',
    },
    diamond: { label: 'Diamond Sourcing', budgets: [] },
  };

  function adContactPage() {
    return {
      intent: 'engagement',
      budget: INTENTS.engagement.defaultBudget,
      submitted: false,
      submitting: false,
      errorMsg: '',

      // Validate, then submit natively to Shopify's contact endpoint. Shopify
      // emails the store and redirects back with ?contact_posted=true, which
      // init() detects to show the success state. $el.submit() bypasses this
      // @submit handler (no recursion).
      submitForm($el) {
        this.errorMsg = '';
        var nameEl  = $el.querySelector('[name="contact[name]"]');
        var emailEl = $el.querySelector('[name="contact[email]"]');
        var name  = nameEl  ? nameEl.value.trim()  : '';
        var email = emailEl ? emailEl.value.trim() : '';
        if (!name)  { this.errorMsg = 'Please enter your name.'; if (nameEl) nameEl.focus(); return; }
        if (!/.+@.+\..+/.test(email)) { this.errorMsg = 'Please enter a valid email address.'; if (emailEl) emailEl.focus(); return; }
        this.submitting = true;
        $el.submit();
      },

      init() {
        // Shopify redirects to ?contact_posted=true after a successful native submit
        try {
          const p = new URLSearchParams(window.location.search);
          if (p.get('contact_posted') === 'true') {
            this.submitted = true;
            this.$nextTick(() => {
              const el = document.querySelector('.ad-contact__success');
              if (el && el.scrollIntoView) el.scrollIntoView({ block: 'center', behavior: 'smooth' });
            });
          }
        } catch (e) {}
      },

      get intentConfig() { return INTENTS[this.intent] || INTENTS.engagement; },
      get budgets() { return this.intentConfig.budgets; },

      selectIntent(key) {
        this.intent = key;
        this.budget = INTENTS[key] ? (INTENTS[key].defaultBudget || '') : '';
      },
      selectBudget(val) { this.budget = val; },
      isIntent(key) { return this.intent === key; },
      isBudget(val) { return this.budget === val; },

      openWhatsApp() { if (CONFIG.whatsappUrl) window.open(CONFIG.whatsappUrl, '_blank'); },
      openCalendly() {
        if (!CONFIG.calendlyUrl) return;
        if (typeof Calendly !== 'undefined') { Calendly.initPopupWidget({ url: CONFIG.calendlyUrl }); }
        else { window.open(CONFIG.calendlyUrl, '_blank'); }
      },
    };
  }

  document.addEventListener('alpine:init', () => {
    Alpine.data('adContactPage', adContactPage);
  });
})();
